import { HeroId } from "../../../../shared/src/index.ts";
import type { VoiceScript } from "../voice-types.ts";

const script = {
  hero: HeroId.Lowkey,
  voices: {
    main: {
      description:
        "silky trickster tenor, sly aristocratic wit, nimble theatrical pauses, smiling danger, close velvet mic with a faint mischievous echo",
      seed: 11009,
      guidance: 0.76,
      loudness: 0.78,
      fx: { reverb: 0.14, eq: "warm" },
    },
  },
  lines: {
    select: [
      {
        id: "select_1",
        text: "I am Lowkey, God of Mischief and the King of Asgard!",
      },
      { id: "select_2", text: "I am Lowkey… or am I?" },
      { id: "select_3", text: "Make way for the God of Mischief." },
      { id: "select_4", text: "Lowkey Laufeyson, at your service." },
      {
        id: "select_5",
        text: "I am Lowkey, of Asgard, and I am burdened with glorious purpose.",
      },
    ],
    spawn: [
      { id: "spawn_1", text: "These runes shall be the key to my victory!" },
      { id: "spawn_2", text: "We make quite the powerful pair, milady!" },
      {
        id: "spawn_3",
        text: "I'm sure no one will mind if I borrow a soul or two…",
      },
      {
        id: "spawn_4",
        text: "Ah! The Queen of the Dead grants me her blessing!",
      },
      {
        id: "spawn_5",
        text: "Sorcery and deception always defeat the clenched fist.",
      },
      {
        id: "spawn_6",
        text: "Time has unravelled. Who will stitch it together again? Me.",
      },
      {
        id: "spawn_7",
        text: "What is a hero? An overgrown child with a weapon.",
      },
      { id: "spawn_8", text: "I can be anyone, but I choose to be Lowkey." },
      {
        id: "spawn_9",
        text: "Some may call this entanglement CHAOS; I only see… opportunities.",
      },
      { id: "spawn_10", text: "I too am a son of Odin." },
      { id: "spawn_11", text: "Asgard needed new leadership. It needed me." },
      {
        id: "spawn_12",
        text: "I have seen many futures, and most of them are bad.",
      },
      {
        id: "spawn_13",
        text: "Doom has overreached, and we must correct him.",
      },
      {
        id: "spawn_14",
        text: "When Doom has been brought to heel, I will choose Asgard's future.",
      },
      {
        id: "spawn_15",
        text: "Without chaos, life becomes a predictable, orderly prison.",
      },
      { id: "spawn_16", text: "I am accused of loving chaos. It is true." },
      { id: "spawn_17", text: "Don't lie to me. I INVENTED every trick." },
      {
        id: "spawn_18",
        text: "God of Lies? If you wish. What society can exist without lies?",
      },
      {
        id: "spawn_19",
        text: "I am wily, unreliable, vindictive… and yet oddly compelling. Don't you think?",
      },
      {
        id: "spawn_20",
        text: "Why would anyone want order when they could enjoy chaos?",
      },
      {
        id: "spawn_21",
        text: "Everyone loves a trickster — until the trick is played on them.",
      },
      {
        id: "spawn_22",
        text: "You were made to be ruled. In the end, you will always kneel.",
      },
    ],
    respawn: [
      { id: "respawn_1", text: "Ehhh, they dare to lay hands on ME?" },
      { id: "respawn_2", text: "That was nothing for a god." },
      { id: "respawn_3", text: "Greetings! What did I miss?" },
      {
        id: "respawn_4",
        text: "That's right, let your enemies underestimate you.",
      },
      { id: "respawn_5", text: "I always come back." },
      { id: "respawn_6", text: "And here we go again." },
      { id: "respawn_7", text: "Nothing keeps me down for long." },
      { id: "respawn_8", text: "Another go." },
    ],
    ult_ally: [{ id: "ult_ally", text: "Bring on the chaos." }],
    ult_enemy: [{ id: "ult_enemy", text: "Your powers are mine!" }],
    secondary: [
      { id: "secondary_1", text: "Time to vanish." },
      { id: "secondary_2", text: "I'm gone." },
      { id: "secondary_3", text: "I'm everywhere." },
      { id: "secondary_4", text: "Come to me, my illusion." },
      { id: "secondary_5", text: "What a lovely trick!" },
      { id: "secondary_6", text: "The more of me, the better!" },
    ],
    ability2: [
      { id: "ability2_1", text: "The more the merrier." },
      { id: "ability2_2", text: "I outnumber you." },
      { id: "ability2_3", text: "I have many faces~" },
      { id: "ability2_4", text: "Who will be the lucky one?" },
      { id: "ability2_5", text: "Your mind is mine!" },
      { id: "ability2_6", text: "You will do just fine…" },
    ],
    ability1: [
      { id: "ability1_1", text: "Get in there." },
      { id: "ability1_2", text: "I still need you." },
      { id: "ability1_3", text: "Ha! Thank me later." },
      { id: "ability1_4", text: "Kneel before me!" },
      { id: "ability1_5", text: "Lowkey rules all!" },
      { id: "ability1_6", text: "You are beneath me!" },
    ],
    kill: [
      { id: "kill_1", text: "I have triumphed. As always." },
      { id: "kill_2", text: "I am more than just a trickster." },
      { id: "kill_3", text: "May you enjoy Hel." },
      { id: "kill_4", text: "Never stood a chance." },
      { id: "kill_5", text: "As it should be." },
      { id: "kill_6", text: "...My favorite trick!" },
      { id: "kill_7", text: "Another fallen foe." },
      { id: "kill_8", text: "I triumph again!" },
    ],
    multikill: [
      { id: "multikill_1", text: "And there's three." },
      { id: "multikill_2", text: "A mighty troika!" },
      { id: "multikill_3", text: "A triptych of triumph!" },
      { id: "multikill_4", text: "A victory quintet!" },
      { id: "multikill_5", text: "Well. That makes five." },
      { id: "multikill_6", text: "Five. I'm on a bit of a streak." },
      { id: "multikill_7", text: "I am, after all, a god." },
      { id: "multikill_8", text: "Mortals just can't keep up." },
      { id: "multikill_9", text: "What were the rest of you doing?" },
    ],
    low_hp: [
      { id: "low_hp_1", text: "Strong medicine!" },
      { id: "low_hp_2", text: "A mighty boost!" },
    ],
    healed: [
      { id: "healed_1", text: "My thanks, healer." },
      { id: "healed_2", text: "Ah...Bless the healing arts." },
      { id: "healed_3", text: "Rightfully mine." },
      { id: "healed_4", text: "Ah, rejuvenation!" },
    ],
    victory: [
      {
        id: "victory_1",
        text: "Of course, the God of Mischief proved his might and struck down his foes!",
      },
      {
        id: "victory_2",
        text: "The heroes foiled Lowkey's scheme and won the battle! Huzzah.",
      },
      {
        id: "victory_3",
        text: "Huzzah! Ultron is utterly obliterated! Yet another triumph for the mighty Avengers!",
      },
    ],
    defeat: [
      {
        id: "defeat",
        text: "As I feared… Against the cold perfection of the machine, humanity's odds were always slim…",
      },
    ],
  },
} satisfies VoiceScript;

export default script;
